import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateClassRoleDto {
  @ApiProperty({ type: 'string', description: 'Code du rôle de classe', example: 'TEACHER' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    type: 'string',
    description: 'Nom du rôle de classe',
    example: 'Enseignant',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
